import type { HelpFile } from '../../types/help'
import { PreviewPaneTestIds } from '../../../testids/PreviewPaneTestIds'

export const previewPaneHelp: HelpFile = {
  docPage: '/docs/admin/form-layout-designer',
  texts: {
    [PreviewPaneTestIds.exitPreviewBtn]:
      'Vorschaumodus verlassen und zum Layout-Designer zurückkehren.',
  },
}
